// src/config.js
// ============================================================
// ScholarSync AI — Frontend Config
// ============================================================
// Auth (S76 security fix, #112): the API secret is NEVER shipped in this
// bundle. Logged-in users send their JWT via authHeaders(). The admin panel
// sends the secret the admin typed into AdminGuard (sessionStorage only).
// ============================================================

export const API_URL    = "https://scholarsync-platform-production.up.railway.app";

/**
 * Returns fetch headers with the correct auth credential.
 * - If a JWT token exists in localStorage → uses Bearer token
 * - Otherwise → no credential (request is unauthenticated)
 *
 * Usage:
 *   fetch(`${API_URL}/api/matches/${id}`, { headers: authHeaders() })
 */
export function authHeaders(extraHeaders = {}) {
  const token = localStorage.getItem('ss_token');
  const headers = {
    'Content-Type': 'application/json',
    ...extraHeaders,
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

// Admin panel only: the secret the admin entered in AdminGuard (kept in
// sessionStorage for the tab). Never hardcoded.
export const ADMIN_SESSION_KEY = 'ysf_admin_verified';
export function adminHeaders(extraHeaders = {}) {
  const secret = sessionStorage.getItem(ADMIN_SESSION_KEY) || '';
  return { 'Content-Type': 'application/json', 'x-api-secret': secret, ...extraHeaders };
}
